export const formatDate = (dateString) => {
    const dateObj = new Date(dateString);
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    const formattedDate = dateObj.toLocaleDateString('en-US', options);
    return formattedDate;
}

export const dateSaperator = (dateString) => {
    const dateObj = new Date(dateString);
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    const dateParts = dateObj
        .toLocaleDateString('en-US', options)
        .split(" ");
    
    const date = dateParts[1].substring(0, dateParts[1].length-1);
    const timeString = dateObj.toLocaleTimeString();

    return { 
        date, 
        month: dateParts[0], 
        year: dateParts[2],
        time: timeString
    };
}

export const shortStr = (str, lengthLimit) => {
    if (str?.length > lengthLimit) {
        return str.substring(0, lengthLimit) + "...";    
    }
    
    return str;
}